import { defineEntity } from '@juvare/platform-app/App';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { onAuthGet, onAuthList, onAuthPost, onMigrate, onTransformColumns } from './callbacks';
export const fileVersionEntityName = 'documentLibraryFileVersion';
export const fileVersionColumns = defineColumns({
    version: {
        type: 'number-required',
    },
    checkInBy: {
        type: 'id',
    },
    checkInByName: {
        type: 'string',
    },
    contentLength: {
        type: 'number-required',
    },
    comment: {
        type: 'string',
    },
    fileId: {
        type: 'id-required',
        index: true,
    },
});
export const fileVersionEntity = defineEntity({
    version: 1,
    columns: fileVersionColumns,
    onMigrate: onMigrate,
    onTransformColumns: (context, params) => onTransformColumns(context, params),
    onAuthGet: onAuthGet,
    onAuthList: onAuthList,
    onAuthPost: onAuthPost,
});
